import { format, parseISO } from 'date-fns';
import { IOffsetPaginationMapper } from '~/types/Pagination';
import {
  ICandidateListViewEntity,
  IGetCandidateListApiResponse,
  IGetCandidateListPayload,
  IGetCandidateListResult,
} from '../types';
import { tryCatch } from '~/utils/TryCatch';

const toGetCandidateListApiQueryParams = (
  payload: IGetCandidateListPayload,
): Record<string, any> => {
  // Convert status array to comma-separated string for API
  const statusParam = payload.status ? payload.status.join(',') : undefined;

  const params = {
    orderBy: payload.orderBy,
    orderDirection: payload.orderDirection,
    page: payload.page,
    pageSize: payload.limit,
    status: statusParam,
  };

  return Object.fromEntries(Object.entries(params).filter(([, value]) => !!value));
};

const toGetCandidateListResult = ({
  data,
  metadata,
  pagination,
}: IGetCandidateListApiResponse): IGetCandidateListResult => {
  const layout = 'EEE, MMM dd, yyyy';

  return {
    data: data.map((it) => {
      const tryParseCreatedAt = tryCatch(() => format(parseISO(it.createdAt), layout));
      const tryParseUpdatedAt = tryCatch(() => format(parseISO(it.updatedAt), layout));

      return {
        createdAt: tryParseCreatedAt.ok ? tryParseCreatedAt.data : '',
        id: it.id,
        isShortlisted: it.isShortlisted,
        pendingApplicationCount: it.pendingApplicationCount,
        professional: {
          id: it.professionalId,
          name: it.professionalName,
          picture: it.professionalPicture,
        },
        officeStatus: it.officeStatus,
        updatedAt: tryParseUpdatedAt.ok ? tryParseUpdatedAt.data : '',
        onsiteInterviewId: it.onsiteInterviewId,
        yearsOfExperience: it.yearsOfExperience,
      } satisfies ICandidateListViewEntity;
    }),
    pagination: IOffsetPaginationMapper.fromApi(pagination),
    statistics: {
      tabs: {
        all: metadata.tabs.all,
        app_expired: metadata.tabs.appExpired,
        applied: metadata.tabs.applied,
        cancelled: 0,
        hired: metadata.tabs.hired,
        interviewed: metadata.tabs.interviewed,
        new: metadata.tabs.new,
        rejected: metadata.tabs.rejected,
        scheduled: metadata.tabs.scheduled,
      },
    },
  } satisfies IGetCandidateListResult;
};

export const CandidateAdapters = {
  toGetCandidateListApiQueryParams,
  toGetCandidateListResult,
};
